import React, { Component } from 'react';


class Messages extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            message: false,
            messageStage: false     
        };
      }



 
    render() {
        return (
            <div className="thanksStage absolute centeredContent bgRed wT centerT">
                <h2 className="fullStage centeredContent">{this.props.successMessage}</h2>
            </div>
        )
    }
  }
  
  export default Messages;


// WEBPACK FOOTER //
// ./src/components/contact/success.js